export const SIDEBAR_MODE = {
  DELETE: "delete",
  EDIT: "edit",
  ADD: "add new",
};
